import { drawTextLayer } from "./drawTextLayer";
import { createCountdownTicker } from "./overlays/countdownTicker";

/**
 * The text layer of the engine. Drawn with every frame; while the bar timer
 * is on screen it is also redrawn alone once a second, without the WebGL
 * layer and the layout (no frame, no buffers). The same happens when only
 * texts change (live PnL of positions). When a frame is already scheduled
 * the redraw is left to it.
 *
 * @param {object} engine - ChartEngine (see drawTextLayer), scheduler
 * @returns {{ draw: (frame: object) => void, redraw: () => void, destroy: () => void }}
 */
export const createTextFrame = (engine) => {
  let lastFrame = null;

  const redraw = () => {
    if (lastFrame && !engine.isDestroyed && !engine.scheduler.isFramePending) draw();
  };

  const ticker = createCountdownTicker(redraw);

  function draw() {
    ticker.setRunning(drawTextLayer(engine, lastFrame));
  }

  return {
    /** @param {object} frame - from drawFrame */
    draw: (frame) => {
      lastFrame = frame;
      draw();
    },

    /** Redraws the text of the last frame with the current texts, e.g. a new PnL. */
    redraw,

    destroy: ticker.stop,
  };
};
